import { render, staticRenderFns } from "./FeedbackRatings.vue?vue&type=template&id=76bb9ad9&scoped=true"
import script from "./FeedbackRatings.vue?vue&type=script&lang=ts"
export * from "./FeedbackRatings.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackRatings.vue?vue&type=style&index=0&id=76bb9ad9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bb9ad9",
  null
  
)

export default component.exports